<template>
    <div>
        <ul :class="{ 'grid' : true, 'grid--loading' : $wait.is('users') }">
            <!-- Error while loading -->
            <li class="grid__error col-12" v-if="error">
                <span class="h2">Unable to load users.</span>
                <button class="btn btn--link" @click.prevent="load">Retry</button>
            </li>
            <template v-else-if="users">
                <li v-for="user in users" class="col-md-4">
                    <UserCard :user="user"></UserCard>
                </li>
            </template>
        </ul>
        <paginate
            v-model="page"
            :page-count="max_page"
            :page-range="3"
            :margin-pages="1"
            :click-handler="getUsers"
            :hide-prev-next="true"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :active-class="'page-item--active'"
        />
    </div>
</template>
<script>
import API from './../../api';
import Paginate from 'vuejs-paginate';
import FilterableGrid from './FilterableGrid';
import UserCard from '../User/UserCard';

export default {
    name: 'GridUsers',
    mixins: [FilterableGrid],
    components: {
        UserCard,
        Paginate,
    },
    data() {
        return {
            users: [],
            page: 1,
            max_page: 0,
            error: false,
        }
    },
    methods: {
        getUsers(page) {
            this.$wait.start('users');

            API.getUsers({
                per_page: 12,
                page: page,
                sort: 'last_name:asc',
                ...this.filters,
            }).then(response => {
                this.error = false;
                this.max_page = response.meta.last_page;
                this.users = response.data;
            }).catch(() => {
                this.error = true;
            }).finally(() => this.$wait.end('users'));
        },
        load() {
            this.getUsers(this.page);
        },
    },
    created() {
        this.getUsers(1);
    },
}
</script>
